import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Form, Loader } from 'semantic-ui-react';
import { getWithAuth } from 'src/api';

export const PTP_TEMPLATE_ID_KEY = 'cn.lp.ptptemplateid';

export const PTPLinkTemplate = () => {
  const [projectId, ptpLinks] = useSelector((state: any) => [
    state.mainFrame.projectId,
    state.mainFrame.ptpLinks,
  ]);
  const storedId = localStorage.getItem(PTP_TEMPLATE_ID_KEY);
  const [selected, setSelected] = useState(storedId);

  const linkIds = ptpLinks?.features.map((link) => link.properties.id) ?? [];
  const queryKey = [projectId, ...linkIds];

  const { data: linkSummary, isLoading } = useQuery({
    queryKey,
    queryFn: async () => {
      return await getWithAuth(`project/${projectId}/ptp/summary`);
    },
    initialData: null,
    retry: false,
    enabled: true,
  });

  useEffect(() => {
    if (!linkIds.includes(selected) && selected !== 'none') {
      setSelected('none');
    }
  }, [linkIds, storedId]);

  if (isLoading || linkSummary === null || ptpLinks == null) {
    return <Loader active inline />;
  }

  const summaryLookup = Object.fromEntries(
    linkSummary.map((link) => [link.id, link])
  );

  let nameOptions = [
    { key: 'none', text: '<no template - default settings>', value: 'none' },
  ];

  if (ptpLinks.features) {
    const linkOptions = ptpLinks.features
      .map((f, idx) => {
        const id = f.properties.id;
        const name = f.properties.name;
        const summaryInfo = summaryLookup[id];
        let textLabel = name;
        if (summaryInfo) {
          textLabel += ` [${summaryInfo.bands} / ${summaryInfo.products}]`;
        }
        return { key: `${idx}-${name}`, text: textLabel, value: id };
      })
      .sort((o1, o2) => o1.text.localeCompare(o2.text));

    nameOptions = nameOptions.concat(linkOptions);
  }

  return (
    <Form.Field>
      <label>
        <FormattedMessage
          id="ptpMode.existingPTPLink"
          defaultMessage="Configure From Existing PTP Link"
        />
      </label>
      <Form.Select
        options={nameOptions}
        value={selected}
        onChange={(_, data) => {
          const newId = data.value.toString();
          if (newId === 'none') {
            localStorage.removeItem(PTP_TEMPLATE_ID_KEY);
          } else {
            localStorage.setItem(PTP_TEMPLATE_ID_KEY, newId);
          }
          setSelected(newId);
        }}
      />
    </Form.Field>
  );
};
